import React from "react"
import { graphql, useStaticQuery } from "gatsby"

const ComponentName = ({ logoImages }) => {
  const data = useStaticQuery(graphql`
    {
      allFile(
        filter: { relativeDirectory: { eq: "gateway/GlobalBrandz" } }
        sort: { fields: childImageSharp___fixed___originalName }
      ) {
        edges {
          node {
            childImageSharp {
              fixed(width: 240, fit: CONTAIN) {
                src
                width
                height
                originalName
              }
            }
            name
            publicURL
          }
        }
      }
    }
  `)
  var logosArray = [];
  var imagesNamesArray = [];
  for (let i = 0; i < data.allFile.edges.length; i++) {
    imagesNamesArray.push(data.allFile.edges[i].node.name)
  }
  for (let i = 0; i < logoImages.length; i++) {
    const imageIndex = imagesNamesArray.indexOf(logoImages[i]);
    const imageURL = data?.allFile?.edges[imageIndex]?.node?.childImageSharp?.fixed?.src
      ?? data?.allFile?.edges[imageIndex]?.node?.publicURL
    const width = data?.allFile.edges[imageIndex]?.node?.childImageSharp?.fixed?.width ?? null
    const height = data?.allFile.edges[imageIndex]?.node?.childImageSharp?.fixed?.height ?? null
    logosArray.push(<div className="logo"><img src={imageURL} alt={logoImages[i] + " logo"} width={width}
                                               height={height} /></div>)
  }
  return (
    <div className="logos mt-3">
      {logosArray}
    </div>
  )
}

export default ComponentName

